export const ON_CHANGE_FORM_FIELDS_ACTION = '@notaFiscalDevedor/ON_CHANGE_FORM_FIELDS_ACTION';
export const SET_SIMPLE_NOTA_FISCAL_DEVEDOR_ACTION = '@notaFiscalDevedor/SET_SIMPLE_NOTA_FISCAL_DEVEDOR_ACTION';
export const LIST_IDS = '@notaFiscalDevedor/LIST_IDS';
export const SET_COMMON_ACTION = '@notaFiscalDevedor/SET_COMMON_ACTION';

export const SET_BUSCAR_DADOS_TABELA = '@notaFiscalDevedor/SET_BUSCAR_DADOS_TABELA';
export const GERAR_NOTA_FISCAL_DEVEDOR = '@notaFiscalDevedor/GERAR_NOTA_FISCAL_DEVEDOR';
export const EXPORTAR_NOTA_FISCAL_DEVEDOR = '@notaFiscalDevedor/EXPORTAR_NOTA_FISCAL_DEVEDOR';
